<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Area/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>